// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bbe_a"};